import { SupportModals } from '@bingads-webui-react/support-modals';
import { withMergedI18n } from '@bingads-webui-campaign-react/i18n-merger';

const Feature = withMergedI18n(
  SupportModals,
  import(/* webpackPreload: true, webpackChunkName: "support-feature.module.l10n" */'./support-module.l10n')
);

export default Feature;
